var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.insertion && _vm.insertion.status)?_c('tag',{attrs:{"type":_vm.insertion.status,"size":"mini"}},[_vm._v("\n    "+_vm._s(_vm._f("trans")(_vm.insertion.status))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }